module.exports = __webpack_public_path__ + "media/assets/images/icon_twitter-091c1895fb835709ed13c637860f3ab0.png";